<template>
  <div class="form-group">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.form-group {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: -$grid-margin-width * 0.5;
  margin-right: -$grid-margin-width * 0.5;

  &:last-child {
    :slotted(.form-section) {
      margin-bottom: 0;
    }
  }
}
</style>
